<template>
  <v-container id="org-list">
    <new-org-form
      v-if="isInternal"
      style="position: absolute; right: 48px; top: 8px;"
    />
    <valkyrie-list
      :list-data="listData"
      :pagination="orgListPagination"
      :list-name="'Organizations'"
      :pagination-text="paginationText"
      :headers.sync="headers"
      :is-loading="loading"
      rows-selectable
      @update-pagination="handleUpdatePagination"
    >
      <template v-slot:list-header>
        <default-list-header
          :searchable="searchable && hasDataToQuery"
          :exportable="exportable && hasDataToQuery"
          :pagination-text="paginationText"
          @search="handleUpdateSearch"
          @export-csv="exportCSV('Organizations')"
        />
      </template>
      <!-- eslint-disable vue/valid-v-slot -->
      <template #item.name="{item}">
        <router-link
          :to="{ name: 'Organization Details', params: {orgId: `${item.id}` } }"
          class="org-name"
        >
          {{ item.name }}
        </router-link>
      </template>
      <template #item.sensorsOnlineOffline="{ item }">
        {{ item.sensorsOnline }}/{{ item.sensorsOffline }}
      </template>
      <template #item.responseCenter="{item}">
        <v-row justify="center">
          <v-simple-checkbox
            v-model="item.responseCenter"
            :ripple="false"
            color="success"
            @input="updateNightAgent(item)"
          />
        </v-row>
      </template>
      <template slot="empty-state">
        <empty-state
          icon="$faCity"
          text="No organizations found"
        />
      </template>
    </valkyrie-list>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import listMixin from '@/helpers/list-mixin'
  import listControllerMixin from '@/helpers/list-controller-mixin'
  import ValkyrieList from '@/components/ValkyrieList.vue'
  import DefaultListHeader from '@/components/ValkyrieListDefaultHeader.vue'
  import EmptyState from '../../components/base/EmptyState.vue'
  import NewOrgForm from '../../components/orgs/InternalUserCreateNewOrgForm.vue'
  import paginationHelper from '@/helpers/pagination-helper'
  import Toggle from '@/components/base/Toggle.vue'

  export default {
    name: 'OrganizationsList',
    components: { ValkyrieList, DefaultListHeader, EmptyState, NewOrgForm, Toggle },
    mixins: [listMixin, listControllerMixin],
    props: {
      searchable: {
        type: Boolean,
        default: true,
      },
      exportable: {
        type: Boolean,
        default: true,
      },
      filterable: {
        type: Boolean,
        default: false,
      },
      hasFilters: {
        type: Boolean,
        default: false,
      },
      filterBy: {
        type: String,
        default: '',
      },
    },
    data: () => ({
      loading: false,
      search: '',
      hasDataToQuery: false,
      payload: {
        listType: 'orgs',
        fileName: 'organizations.csv',
      },
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Created Date',
          value: 'createdAt',
        },
        {
          text: 'Properties',
          value: 'propertyCount',
        },
        {
          text: 'Active Properties',
          value: 'activePropertyCount',
        },
        {
          text: 'Sensors Online/Offline',
          value: 'sensorsOnlineOffline',
        },
        {
          text: 'Night Agent',
          value: 'responseCenter',
          align: 'center',
        },
      ],
    }),
    computed: {
      ...mapGetters({
        isInternal: 'Permissions/isInternal',
        total: 'Organizations/orgListTotal',
      }),
      paginationText () {
        return paginationHelper(this.pageNum, this.perPage, this.total)
      },
      listAPIPath () {
        return `${this.$store.state.baseURL}/orgs/list`
      },
      orgListPagination () {
        return { ...this.pagination, total: this.total }
      },
    },
    created () {
      this.initializeOrgList()
    },
    destroyed () { clearInterval(this.timeout) },
    methods: {
      initializeOrgList () {
        this.fetchList().then((res) => {
          this.updateTotal(res.data.pagination.total)
          this.hasDataToQuery = res.data.pagination.total > 0
        })
      },
      updateTotal (total) {
        this.$store.commit('Organizations/updateTotal', total)
      },
      updateNightAgent (org) {
        this.$store.dispatch('Reservations/enableNightAgent', org)
      },
    },
  }
</script>
<style lang="scss">
#org-list {
  padding: 12px 0;
  .org-name {
    color: $muted;
    font-weight: 600;
    letter-spacing: 0.191002px;
    text-decoration: none;
  }
}

</style>
